const init = {
    status:false,
    message:'',
    data:{}
}

export const permissionReducer = (state = init, action) => {
    switch (action.type){
        case 'PERMISSION_START':
            return state;
        case 'PERMISSION_FAIL':
            return {...state, message:action.payload.message,status:false};
        case 'PERMISSION_SUCCESS':
            return {...state, data:action.payload.data, status:true };
        default:
            return state;
    }
};